// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SendIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m27.984 14.25-21-11.986a2 2 0 0 0-2.868 2.401l3.875 11.309v.025L4.116 27.332a2 2 0 0 0 2.874 2.405l20.989-12.006a2 2 0 0 0 .006-3.486l-.001.005ZM6 28v-.011L9.768 17H17a1 1 0 1 0 0-2H9.778L6.008 4.015 6 4l21 11.979L6 28Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
